import { forwardRef } from 'react';

import { getDate } from 'date-fns';

import { dayCellBackground, dayCellInner } from './DatePicker.css';
import { DatePickerDayProps } from './types';

export const DatePickerDay = forwardRef<HTMLDivElement, DatePickerDayProps>(
  (
    {
      date,
      isSelected = false,
      isToday = false,
      isRangeStart = false,
      isRangeEnd = false,
      isInRange = false,
      isOutsideMonth = false,
      isDisabled = false,
      isStartOfWeek = false,
      isEndOfWeek = false,
      onClick,
      onMouseEnter,
      onMouseLeave,
    },
    ref,
  ) => {
    const handleClick = () => {
      if (!isDisabled && onClick) {
        onClick(date);
      }
    };

    const handleMouseEnter = () => {
      if (!isDisabled && onMouseEnter) {
        onMouseEnter(date);
      }
    };

    return (
      <div
        ref={ref}
        className={dayCellBackground({
          outsideMonth: isOutsideMonth,
          rangeStart: isRangeStart,
          rangeEnd: isRangeEnd,
          inRange: isInRange,
          disabled: isDisabled,
          startOfWeek: isStartOfWeek,
          endOfWeek: isEndOfWeek,
        })}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div
          className={dayCellInner({
            today: isToday,
            selected: isSelected,
            rangeStart: isRangeStart,
            rangeEnd: isRangeEnd,
            disabled: isDisabled,
          })}
        >
          {getDate(date)}
        </div>
      </div>
    );
  },
);

DatePickerDay.displayName = 'DatePickerDay';
